import {DomainAncestor, entityConfig} from "../../../core/common/domain/DomainAncestor";
import {observable} from "mobx";
import {ID} from "../../../core/metamodel/metaConstant";
import {LovItem} from "../../../core/metamodel/mdEntity";


@entityConfig()
export class SubCriterionParameterValue extends DomainAncestor {

  @observable valueId: number;
  @observable label: string;
  @observable value: number;
  @observable countLimit: number;
  @observable dependsOn: LovItem[];

  constructor(json: any) {
    super(json);
  }

  public getId(): ID {
    return this.valueId;
  }

  public setId(id: ID): void {
    this.valueId = <number>id;
  }
}



// WEBPACK FOOTER //
// ./src/sbtool/domain/criterion/subCriterionParameterValueDomain.ts